export default __webpack_public_path__ + "static/media/paytm.5d8f814c.svg";